import React from "react";
import "./Items.css";
import itemImg from "../../../Assets/items.png";
import AdminHeader from "../../../Component/AdminHeader/AdminHeader";
import { FaClock, FaEdit } from "react-icons/fa";
import useVendorItems from "./UseItems";

const VendorItems = () => {
  const {
    search,
    setSearch,
    filterType,
    setFilterType,
    filteredItems,
    handleToggleAvailability,
  } = useVendorItems();

  return (
    <div className="items-page">
      <AdminHeader />

      {/* Outlet Info */}
      <div className="outlet-details">
        <h1>Spicy Delights</h1>
        <p className="subtitle">Serving popular Indian Delicious</p>
        <p className="owner">Owner: John Doe</p>

        <div className="timing-box">
          <span className="opens"><FaClock /> Opens at 10:00 AM</span>
          <span className="closes"><FaClock /> Closes at 8:00 PM</span>
        </div>
      </div>

      {/* Search + Filters */}
      <div className="toolbar">
        <input
          className="search"
          type="text"
          placeholder="Search items by name..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <div className="filters-vendor-items">
          <span
            className={`filter ${filterType === "All" ? "active" : ""}`}
            onClick={() => setFilterType("All")}
          >
            All
          </span>

          <span
            className={`filter available ${filterType === "Available" ? "active" : ""}`}
            onClick={() => setFilterType("Available")}
          >
            Available
          </span>

          <span
            className={`filter paused ${filterType === "Paused" ? "active" : ""}`}
            onClick={() => setFilterType("Paused")}
          >
            Paused
          </span>
        </div>

        <div className="order-button">
          <button>Orders</button>
        </div>
      </div>

      {/* Items Table */}
      <div className="table-box">
        <table className="item-table">
          <thead>
            <tr>
              <th>Item</th>
              <th>Price</th>
              <th>Category</th>
              <th>Availability</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {filteredItems.length ? (
              filteredItems.map((item) => (
                <tr key={item.id}>
                  <td>
                    <div className="item-info">
                      <img src={itemImg} alt="item" className="item-img" />
                      <div>
                        <p className="item-name">{item.name}</p>
                        <p className="item-type">{item.type}</p>
                      </div>
                    </div>
                  </td>

                  <td>
                    <p className="item-price">{item.price}</p>
                    <span className="gst">{item.gst}</span>
                  </td>

                  <td><span className="category-badge">{item.category}</span></td>

                  <td>
                    <div className="availability">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={item.available}
                          onChange={() => handleToggleAvailability(item.id)}
                        />
                        <span className="slider"></span>
                      </label>
                      <span className={item.available ? "status available" : "status paused"}>
                        {item.available ? "Available" : "Paused"}
                      </span>
                    </div>
                  </td>

                  <td>
                    <FaEdit className="edit-icon" />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: "center", padding: 18 }}>
                  No items found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VendorItems;
